// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__fELFv","titles":"styles_titles__3UkED","active":"styles_active__1kA86","content":"styles_content__2dTfq"};